<template>
    <form class="col-md-8 mx-auto" @submit.prevent="onSubmit">
        <div class="loader" v-if="loading"></div>
        <div v-else>
            <page-title :title="$t('administrativePosition.title')" :showTitle="false"></page-title>

            <div class="btn-group" role="group" aria-label="Basic example">
                <button type="button"
                        class="btn btn-primary"
                        @click="backToRegister">
                    <i class="fas fa-th-list"></i> {{ $t('backToList') }}
                </button>
            </div>

            <div class="card row">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('administrativePosition.information') }}</div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="form-group col-12">
                            <label :for="'name' + _uid" class="font-weight-bold required">{{
                                $t('administrativePosition.name') }}</label>
                            <input type="text"
                                   class="form-control"
                                   :id="'name' + _uid"
                                   :name="'name' + _uid"
                                   v-model="administrativePosition.name"
                                   :data-vv-as="$t('administrativePosition.name')"
                                   v-validate="'required'"/>
                            <span class="text-danger"
                                  v-if="errors.has('name' + _uid)">{{ errors.first('name' + _uid) }}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-6">
                            <label :for="'department' + _uid" class="font-weight-bold">{{
                                $t('administrativePosition.department') }}</label>
                            <dropdown :type="'Отдел'"
                                      :load-by-parent-sort="true"
                                      :parent-sort="nomenclature.Department"
                                      v-model="administrativePosition.department"
                                      :data-vv-as="$t('administrativePosition.department')"
                                      :name="'administrativePosition.department' + _uid"
                                      :fieldName="$t('administrativePosition.department')"></dropdown>
                        </div>
                        <div class="form-group col-6">
                            <label :for="'directorate' + _uid" class="font-weight-bold">{{
                                $t('administrativePosition.directorate') }}</label>
                            <dropdown :load-by-parent-sort="true"
                                      :parent-sort="nomenclature.Directorate"
                                      v-model="administrativePosition.directorate"
                                      :data-vv-as="$t('administrativePosition.directorate')"
                                      :name="'administrativePosition.directorate' + _uid"
                                      :fieldName="$t('administrativePosition.directorate')"></dropdown>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-6">
                            <label :for="'managerPosition' + _uid" class="font-weight-bold">{{
                                $t('administrativePosition.managerPosition') }}</label>
                            <dynamicDropdown :apiUrl="`/api/Dropdown/GetAdministrativePositions`"
                                             v-model="administrativePosition.managerPositionId"
                                             :id="'administrativePosition.managerPosition' + _uid"
                                             :name="'administrativePosition.managerPosition' + _uid"
                                             :data-vv-as="$t('administrativePosition.managerPosition')"
                                             :fieldName="$t('administrativePosition.managerPosition')"></dynamicDropdown>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-12">
                            <label :for="'contactDetails' + _uid" class="font-weight-bold required">{{
                                $t('administrativePosition.contactDetails') }}</label>
                            <input type="text"
                                   class="form-control"
                                   :id="'contactDetails' + _uid"
                                   :name="'contactDetails' + _uid"
                                   v-model="administrativePosition.contactDetails"
                                   :data-vv-as="$t('administrativePosition.contactDetails')"
                                   v-validate="'required'"/>
                            <span class="text-danger" v-if="errors.has('contactDetails' + _uid)">{{ errors.first('contactDetails' + _uid) }}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-12">
                            <label :for="'location' + _uid" class="font-weight-bold required">{{
                                $t('administrativePosition.location') }}</label>
                            <input type="text"
                                   class="form-control"
                                   :id="'location' + _uid"
                                   :name="'location' + _uid"
                                   v-model="administrativePosition.location"
                                   :data-vv-as="$t('administrativePosition.location')"
                                   v-validate="'required'"/>
                            <span class="text-danger" v-if="errors.has('location' + _uid)">{{ errors.first('location' + _uid) }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card row mt-5">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('administrativePosition.substitutions') }}</div>
                </div>
                <div class="card-body">
                    <div v-for="(replacement,index) in administrativePosition.replacements" :key="index"
                         class="k-display-flex align-items-sm-center">
                        <div class="col-12 mt-2">
                            <dynamicDropdown :apiUrl="`/api/Dropdown/GetAdministrativePositions`"
                                             v-model="replacement.replacementId"
                                             v-validate="'required'"
                                             :id="'administrativePosition.name' + _uid"
                                             :name="'administrativePosition.name' + _uid"
                                             :data-vv-as="$t('administrativePosition.name')"
                                             :fieldName="$t('administrativePosition.name')"></dynamicDropdown>
                            <span class="text-danger" v-if="errors.has('administrativePosition.name' + _uid)">{{ errors.first('administrativePosition.name' + _uid) }}</span>
                        </div>
                        <i class="fas fa-trash-alt btn-danger pointer"
                           @click="deleteSubstitution(index,replacement)"></i>
                    </div>
                    <button type="button" class="btn btn-primary btn-md mt-3" @click="addSubstitution"><i
                        class="fas fa-plus mr-2"></i>{{ $t('administrativePosition.addSubstitution') }}
                    </button>
                </div>
            </div>
            <div class="card row mt-5">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('otherFields.otherFields') }}</div>
                </div>
                <div class="card-body">
                    <otherFields :otherFields="administrativePosition.otherFields"></otherFields>
                </div>
            </div>

            <AuxiliaryRegister ref="auxiliaryRegisterRef"
                               :register-id="AuxiliaryRegisters.Administrative_positions"
                               register-name="AdministrativePosition"
                               :entry-id="administrativePosition.auxRegisterEntityId"></AuxiliaryRegister>

            <div class="text-center mt-2 mb-5">
                <button type="button" class="btn btn-primary btn" @click="onSubmit">
                    <i class="fas fa-save"></i>
                    {{ $t('buttons.save.btnText') }}
                </button>
            </div>
        </div>
    </form>
</template>

<script>
    import Dropdown from '../../../components/dropdown/NomenclatureDropdown';
    import OtherFields from '../../../components/otherFields/OtherFields.vue';
    import { AdministrativePosition, AdministrativePositionSubstitutions } from '@/models/models';
    import DynamicDropdown from '../../../components/dropdown/DynamicDropdown';
    import PageTitle from '../../../components/common/PageTitle';
    import { NomenclatureParentBySort, AuxiliaryRegisters } from '@/models/enums';
    import AuxiliaryRegister from '@/components/dynamic/AuxiliaryRegister';

    export default {
        components: {
            Dropdown,
            OtherFields,
            DynamicDropdown,
            PageTitle,
            AuxiliaryRegister
        },
        data() {
            return {
                nomenclature: NomenclatureParentBySort,
                id: null,
                administrativePosition: new AdministrativePosition(),
                loading: false,
                isSaved: false,
                AuxiliaryRegisters: AuxiliaryRegisters
            }
        },
        methods: {
            onSubmit() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.administrativePosition.auxRegisterModel = this.$refs.auxiliaryRegisterRef.getDynamicRegisterModelForSubmit();
                        if (this.id) {
                            this.edit();
                        } else {
                            this.create();
                        }
                    }
                })
            },
            backToRegister() {
                this.$router.push('/registers/administrativePositions');
            },
            addSubstitution(event) {
                this.administrativePosition.replacements.push(new AdministrativePositionSubstitutions());
            },
            deleteSubstitution: function (index, replacement) {
                this.administrativePosition.replacements.splice(index, 1);
                this.administrativePosition.deletedIds.push(replacement);
            },
            create() {
                this.loading = true;
                this.$http.post('/api/administrativePosition', this.administrativePosition).then(result => {
                    this.loading = false;
                    this.isSaved = true;
                    this.$vs.notify({
                        title: this.$t('notifications.success'),
                        text: this.$t('notifications.successfulSavedData'),
                        position: 'top-center',
                        color: 'success'
                    });
                    this.backToRegister();
                }).catch(error => {
                    this.loading = false;
                    this.$vs.notify({
                        title: this.$t('notifications.error'),
                        text: this.$helpers.errorText(error),
                        position: 'top-center',
                        color: 'danger'
                    });
                });
            },
            edit() {
                this.loading = true;
                this.$http.put('/api/administrativePosition', this.administrativePosition).then(result => {
                    this.loading = false;
                    this.isSaved = true;
                    this.$vs.notify({
                        title: this.$t('notifications.success'), // TODO:
                        text: this.$t('notifications.successfulSavedData'), // TODO:
                        position: 'top-center',
                        color: 'success'
                    });
                    this.backToRegister();
                }).catch(error => {
                    this.loading = false;
                    this.$vs.notify({
                        title: this.$t('notifications.error'), // TODO:
                        text: this.$helpers.errorText(error), // TODO:
                        position: 'top-center',
                        color: 'danger'
                    });
                });
            },
            loadData() {
                this.loading = true;
                this.$http.get(`/api/administrativePosition/${this.id}`).then(result => {
                    this.administrativePosition = new AdministrativePosition(result.data);
                    this.$store.initialModel = _.cloneDeep(this.administrativePosition);
                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('buttons.load.btnText'),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                }).then(() => { this.loading = false; });
            }
        },
        mounted() {
            this.id = this.$route.params.id;
            if (this.id) {
                this.loadData();
            }
            this.$store.initialModel = _.cloneDeep(this.administrativePosition);
        },
        beforeRouteLeave(to, from, next) {
            if (!_.isEqual(this.$store.initialModel, this.administrativePosition) && !this.isSaved) {
                const answer = window.confirm(this.$t('notifications.leavePage'))
                if (answer) {
                    next()
                } else {
                    next(false)
                }
            } else {
                next()
            }
        },
    }

</script>

<style scoped>
</style>
